const summaryStatuses = {
  WAITING: 'Waiting',
  COMPLETE: 'Complete',
  READY: 'Ready',
  PARTIALLY_RECONCILED: 'Partially reconciled',
};

export default summaryStatuses;
